import React from "react";
import { Box, Card, CardContent, LinearProgress, Stack, Typography } from "@mui/material";

export interface FileUploadStatus {
    file: File;
    progress: number; // 0 - 100
    status: "pending" | "uploading" | "completed" | "failed";
}

interface UploadWidgetProps {
    uploads: FileUploadStatus[];
}

export const FileUploadStatusWidget = React.memo(({ uploads }: UploadWidgetProps) => {
    return (
        <Box p={2}>
            <Typography variant="h5" mb={2}>
                Upload Progress
            </Typography>

            <Stack spacing={2}>
                {uploads.map((upload, idx) => (
                    <Card key={idx} variant="outlined">
                        <CardContent>
                            <Typography variant="subtitle1" noWrap>
                                {upload.file.name}
                            </Typography>

                            <Box display="flex" alignItems="center" mt={1}>
                                <Box flexGrow={1}>
                                    <LinearProgress
                                        variant="determinate"
                                        value={upload.progress}
                                        sx={{
                                            height: 10,
                                            borderRadius: 5,
                                            backgroundColor: (theme) => theme.palette.grey[300],
                                            "& .MuiLinearProgress-bar": {
                                                borderRadius: 5,
                                            },
                                        }}
                                    />
                                </Box>

                                <Box ml={2}>
                                    <Typography variant="body2" color="textSecondary">
                                        {upload.progress}%
                                    </Typography>
                                </Box>
                            </Box>

                            <Box mt={1}>
                                <Typography
                                    variant="body2"
                                    color={
                                        upload.status === "completed"
                                            ? "success.main"
                                            : upload.status === "failed"
                                            ? "error.main"
                                            : "textSecondary"
                                    }>
                                    {upload.status.charAt(0).toUpperCase() + upload.status.slice(1)}
                                </Typography>
                            </Box>
                        </CardContent>
                    </Card>
                ))}
            </Stack>
        </Box>
    );
});

FileUploadStatusWidget.displayName = "FileUploadStatusWidget";
